import {
  FETCH_WORKSPACES_REQUEST, FETCING_WORKSPACES_SUCCEEDED, FETCING_WORKSPACES_FAILED,
  FETCH_WORKSPACE_REQUEST, FETCHING_WORKSPACE_SUCCEEDED, FETCHING_WORKSPACE_FAILED, SWITCH_WORKSPACE,FETCHING_WORKSPACE_REPORT_SUMMARY, 
  FETCHING_WORKSPACE_REPORT_SUMMARY_SUCCEDED, FETCHING_WORKSPACE_REPORT_SUMMARY_FAILED, FETCHING_WORKSPACE_SESSION_ANALYTICS, 
  FETCHING_WORKSPACE_SESSION_ANALYTICS_SUCCEDED, FETCHING_WORKSPACE_SESSION_ANALYTICS_FAILED, FETCHING_WORKSPACE_STORYBOARD_REPORTS,
  FETCHING_WORKSPACE_STORYBOARD_REPORTS_SUCCEDED, FETCHING_WORKSPACE_STORYBOARD_REPORTS_FAILED, FETCHING_WORKSPACE_LEAD_REPORTS,
  FETCHING_WORKSPACE_LEAD_REPORTS_SUCCEDED, FETCHING_WORKSPACE_LEAD_REPORTS_FAILED, FETCHING_WORKSPACE_ASSET_ANALYTICS, FETCHING_WORKSPACE_ASSET_ANALYTICS_SUCCEDED,
  FETCHING_WORKSPACE_ASSET_ANALYTICS_FAILED, FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD, FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD_SUCCEEDED,
  FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD_FAILED, INVALIDATE_STORYBOARD_REPORTS_DOWNLOAD_DATA, FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD, FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED, 
  FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD_FAILED, INVALIDATE_SESSION_ANALYTICS_DOWNLOAD_DATA, FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED,
  FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD, FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD_FAILED, INVALIDATE_LEAD_ANALYTICS_DOWNLOAD_DATA,
  FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD, FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED,
  FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD_FAILED, INVALIDATE_ASSET_ANALYTICS_DOWNLOAD_DATA,
  INVALID_WORKSPACE_REPORTS
} from 'constants/actionTypes';

const storyboardReportsState = {
    pagination: {
      current: -1,
      totalPages: 1
    },
    items: {}
}

const downloadStoryboardReportsState = {
  loading: false,
  items: [],
  pagination: {
    current: -1,
    totalPages: 1,
    hasMore: false
  },
  progress: false,
  completed: false
}

const downloadSessionAnalyticsState = {
  loading: false,
  items: [],
  pagination: {
    current: -1,
    totalPages: 1,
    hasMore: false
  },
  progress: false,
  completed: false
}

const downloadLeadReportsState = {
  loading: false,
  items: [],
  pagination: {
    current: -1,
    totalPages: 1,
    hasMore: false
  },
  progress: false,
  completed: false
}

const downloadAssetAnalyticsState = {
  loading: false,
  items: [],
  pagination: {
    current: -1,
    totalPages: 1,
    hasMore: false
  },
  progress: false,
  completed: false
}
const sessionAnalyticsState = {
  pagination: {
    current: -1,
    totalPages: 1
  },
  items: {}
}

const assetAnalyticsState = {
  pagination: {
    current: -1,
    totalPages: 1
  },
  items: {}
}

const leadAnalyticsState = {
  pagination: {
    current: -1,
    totalPages: 1
  },
  items: {}
}

const initialState = {
  loading: false,
  fetched: false,
  invalidated: false,
  items: [],
  workspace: {
    loading: false,
    item: null
  },
  reports : {
    loading: false,
    summary:{},
    sessions: sessionAnalyticsState,
    storyboardReports: storyboardReportsState,
    leads: leadAnalyticsState,
    assets: assetAnalyticsState,
  },
  download: {
    loading: false,
    storyboardReports: downloadStoryboardReportsState,
    leads: downloadLeadReportsState,
    sessions: downloadSessionAnalyticsState,
    assets: downloadAssetAnalyticsState
  }
}

export function workspaceReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_WORKSPACES_REQUEST: 
      return {
        ...state,
        loading: true,
        invalidated: true,
        fetched: false,
      }

    case FETCING_WORKSPACES_SUCCEEDED: 
      var items = action.payload

      return {
        ...state,
        loading: false,
        fetched: true,
        invalidated: false,
        items: items
      }

    case FETCING_WORKSPACES_FAILED:
      return {
        ...state,
        loading: false,
        fetched: false,
        invalidated: false,
        items: []
      }

    case FETCH_WORKSPACE_REQUEST: 
      return {
        ...state,
        workspace: {
          ...state.workspace,
          loading: true
        }
      }

    case FETCHING_WORKSPACE_SUCCEEDED:
      var item = action.payload
      return {
        ...state,
        workspace: {
          ...state.workspace,
          loading: false,
          item: item
        }
      }
    
    case FETCHING_WORKSPACE_FAILED: 
      return {
        ...state,
        workspace: {
          ...state.workspace,
          loading: false,
          item: null
        }
      }
    
    case SWITCH_WORKSPACE:
      var workspace = action.payload;

      return {
        ...state,
        loading: false,
        invalidated: false,
        workspace: {
          item: workspace
        }
      }

      case FETCHING_WORKSPACE_REPORT_SUMMARY: {
        return {
            ...state,
            reports : {
              ...state.reports,
              loading: true
            }
          }
      }

      case FETCHING_WORKSPACE_REPORT_SUMMARY_SUCCEDED: {
        const response = action.payload;
        return {
            ...state,
            reports : {
              ...state.reports,
              loading: false,
              summary: response
            }
        }
      }

      case FETCHING_WORKSPACE_REPORT_SUMMARY_FAILED: {
        const { error } = action.payload;
  
        return {
            ...state,
            reports : {
              ...state.reports,
              loading: false,
              error: error
            }
        }
      }

      case FETCHING_WORKSPACE_SESSION_ANALYTICS: {
        return {
          ...state,
          reports : {
            ...state.reports,
            sessions:{
              ...state.reports.sessions,
              loading: true,
            }
          }
        }
      }

      case FETCHING_WORKSPACE_SESSION_ANALYTICS_SUCCEDED: {
        const response = action.payload;
        return {
          ...state,
          reports : {
            ...state.reports,
            loading: false,
            sessions:{
              ...state.reports.sessions,
              loading: false,
              items: response.records,
              pagination: {
                ...state.pagination,
                current: response.currentPage,
                totalPages: response.totalPages,
                totalRecordsCount: response.totalRecordsCount
              }
            }
          }
      }
      }

      case FETCHING_WORKSPACE_SESSION_ANALYTICS_FAILED: {
        const { error } = action.payload;
        return {
          ...state,
          reports : {
            ...state.reports,
            loading: false,
            sessions:{
              ...state.reports.sessions,
                loading: false,
                error: error
            }
          }
        }
      }

      case FETCHING_WORKSPACE_STORYBOARD_REPORTS: {
        return {
            ...state,
            reports : {
              ...state.reports,
              storyboardReports:{
                ...state.reports.storyboardReports,
                loading: true,
              }
            }
          }
      }

      case FETCHING_WORKSPACE_STORYBOARD_REPORTS_SUCCEDED: {
        const response = action.payload;
        return {
            ...state,
            reports : {
              ...state.reports,
              loading: false,
              storyboardReports:{
                ...state.reports.storyboardReports,
                loading: false,
                items: response.records,
                pagination: {
                  ...state.pagination,
                  current: response.currentPage,
                  totalPages: response.totalPages,
                  totalRecordsCount: response.totalRecordsCount
                }
              }
            }
        }
      }

      case FETCHING_WORKSPACE_STORYBOARD_REPORTS_FAILED: {
        const { error } = action.payload;
        return {
            ...state,
            reports : {
              ...state.reports,
              loading: false,
              storyboardReports:{
                ...state.reports.storyboardReports,
                  loading: false,
                  error: error
              }
            }
        }
      }

      case FETCHING_WORKSPACE_LEAD_REPORTS: {
        return {
            ...state,
            reports : {
              ...state.reports,
              leads:{
                ...state.reports.leads,
                loading: true,
              }
            }
          }
      }

      case FETCHING_WORKSPACE_LEAD_REPORTS_SUCCEDED: {
        const response = action.payload;
        return {
            ...state,
            reports : {
              ...state.reports,
              loading: false,
              leads:{
                ...state.reports.leads,
                loading: false,
                items: response.records,
                pagination: {
                  ...state.pagination,
                  current: response.currentPage,
                  totalPages: response.totalPages,
                  totalRecordsCount: response.totalRecordsCount
                }
              }
            }
        }
      }

      case FETCHING_WORKSPACE_LEAD_REPORTS_FAILED: {
        const { error } = action.payload;
        return {
            ...state,
            reports : {
              ...state.reports,
              loading: false,
              leads:{
                ...state.reports.leads,
                  loading: false,
                  error: error
              }
            }
        }
      }

      case FETCHING_WORKSPACE_ASSET_ANALYTICS: {
        return {
            ...state,
            reports : {
              ...state.reports,
              assets:{
                ...state.reports.assets,
                loading: true,
              }
            }
          }
      }

      case FETCHING_WORKSPACE_ASSET_ANALYTICS_SUCCEDED: {
        const response = action.payload;
        return {
            ...state,
            reports : {
              ...state.reports,
              loading: false,
              assets:{
                ...state.reports.assets,
                loading: false,
                items: response.records,
                pagination: {
                  ...state.pagination,
                  current: response.currentPage,
                  totalPages: response.totalPages,
                  totalRecordsCount: response.totalRecordsCount
                }
              }
            }
        }
      }

      case FETCHING_WORKSPACE_ASSET_ANALYTICS_FAILED: {
        const { error } = action.payload;
        return {
            ...state,
            reports : {
              ...state.reports,
              loading: false,
              assets:{
                ...state.reports.assets,
                  loading: false,
                  error: error
              }
            }
        }
      }

      case INVALID_WORKSPACE_REPORTS: {
        return {
            ...state,
            reports : {
              ...state.reports,
              loading: false,
              sessions: sessionAnalyticsState,
              storyboardReports: storyboardReportsState,
              leads: leadAnalyticsState,
              assets: assetAnalyticsState,
            },
          }
      }

      case FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD: {
        return {
          ...state,
          download : {
              ...state.download,
              loading: true,
              storyboardReports:{
                  ...state.download.storyboardReports,
                  loading: true,
                  progress: true,
                  completed: false
              }
          }
        }
      }
  
      case FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD_SUCCEEDED: {
        const { response } = action.payload;
  
        var completed = false;
        var progress = true;
  
        const hasMoreItems = response.currentPage < response.totalPages - 1;
  
        if (!hasMoreItems) {
          completed = true;
          progress = false;
        }

          return {
            ...state,
            download : {
              ...state.download,
              loading: false,
              storyboardReports:{
                ...state.download.storyboardReports,
                loading: false,
                items: [
                  ...(state.download.storyboardReports.items || []),
                  ...response.records
                ],
                pagination: {
                  ...state.pagination,
                  current: response.currentPage,
                  totalPages: response.totalPages,
                  totalRecordsCount: response.totalRecordsCount
                },
                completed: completed,
                progress: progress
              }
            }
        }
      }
  
      case FETCHING_STORYBOARD_REPORTS_FOR_DOWNLOAD_FAILED: {
        const { error } = action.payload;

        return {
          ...state,
          download : {
            ...state.download,
            loading: false,
            storyboardReports:{
              ...state.download.storyboardReports,
              loading: false,
              completed: false,
              progress: false,
              error: error
            }
          }
        }
      }

      case INVALIDATE_STORYBOARD_REPORTS_DOWNLOAD_DATA: {
        return {
          ...state,
          download : {
            ...state.download,
            loading: false,
            storyboardReports:{
              ...state.download.storyboardReports,
              loading: false,
              items: [],
              pagination: {
                current: -1,
                totalPages: 1,
                hasMore: false
              },
              progress: false,
              completed: false
            }
          }
        }
      }


      case FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD: {
        return {
          ...state,

          download : {
              ...state.download,
              loading: true,
              sessions:{
                  ...state.download.sessions,
                  loading: true,
                  progress: true,
                  completed: false
              }
          }
        }
      }
  
      case FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED: {
        const { response } = action.payload;
  
        var completed = false;
        var progress = true;
  
        const hasMoreItems = response.currentPage < response.totalPages - 1;
  
        if (!hasMoreItems) {
          completed = true;
          progress = false;
        }

          return {
            ...state,
            download : {
              ...state.download,
              loading: false,
              sessions:{
                ...state.download.sessions,
                loading: false,
                items: [
                  ...(state.download.sessions.items || []),
                  ...response.records
                ],
                pagination: {
                  ...state.pagination,
                  current: response.currentPage,
                  totalPages: response.totalPages,
                  totalRecordsCount: response.totalRecordsCount
                },
                completed: completed,
                progress: progress
              }
            }
        }
      }
  
      case FETCHING_SESSION_ANALYTICS_FOR_DOWNLOAD_FAILED: {
        const { error } = action.payload;

        return {
          ...state,
          download : {
            ...state.download,
            loading: false,
            sessions:{
              ...state.download.sessions,
              loading: false,
              completed: false,
              progress: false,
              error: error
            }
          }
        }
      }

      case INVALIDATE_SESSION_ANALYTICS_DOWNLOAD_DATA: {
        return {
          ...state,
          download : {
            ...state.download,
            loading: false,
            sessions:{
              ...state.download.sessions,
              loading: false,
              items: [],
              pagination: {
                current: -1,
                totalPages: 1,
                hasMore: false
              },
              progress: false,
              completed: false
            }
          }
        }
      }

      case FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD: {
        return {
          ...state,

          download : {
              ...state.download,
              loading: true,
              leads:{
                  ...state.download.leads,
                  loading: true,
                  progress: true,
                  completed: false
              }
          }
        }
      }
  
      case FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED: {
        const { response } = action.payload;
  
        var completed = false;
        var progress = true;
  
        const hasMoreItems = response.currentPage < response.totalPages - 1;
  
        if (!hasMoreItems) {
          completed = true;
          progress = false;
        }

          return {
            ...state,
            download : {
              ...state.download,
              loading: false,
              leads:{
                ...state.download.leads,
                loading: false,
                items: [
                  ...(state.download.leads.items || []),
                  ...response.records
                ],
                pagination: {
                  ...state.pagination,
                  current: response.currentPage,
                  totalPages: response.totalPages,
                  totalRecordsCount: response.totalRecordsCount
                },
                completed: completed,
                progress: progress
              }
            }
        }
      }
  
      case FETCHING_LEAD_ANALYTICS_FOR_DOWNLOAD_FAILED: {
        const { error } = action.payload;

        return {
          ...state,
          download : {
            ...state.download,
            loading: false,
            leads:{
              ...state.download.leads,
              loading: false,
              completed: false,
              progress: false,
              error: error
            }
          }
        }
      }

      case INVALIDATE_LEAD_ANALYTICS_DOWNLOAD_DATA: {
        return {
          ...state,
          download : {
            ...state.download,
            loading: false,
            leads:{
              ...state.download.leads,
              loading: false,
              items: [],
              pagination: {
                current: -1,
                totalPages: 1,
                hasMore: false
              },
              progress: false,
              completed: false
            }
          }
        }
      }

      case FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD: {
        return {
          ...state,

          download : {
              ...state.download,
              loading: true,
              assets:{
                  ...state.download.assets,
                  loading: true,
                  progress: true,
                  completed: false
              }
          }
        }
      }
  
      case FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED: {
        const { response } = action.payload;
  
        var completed = false;
        var progress = true;
  
        const hasMoreItems = response.currentPage < response.totalPages - 1;
  
        if (!hasMoreItems) {
          completed = true;
          progress = false;
        }

          return {
            ...state,
            download : {
              ...state.download,
              loading: false,
              assets:{
                ...state.download.assets,
                loading: false,
                items: [
                  ...(state.download.assets.items || []),
                  ...response.records
                ],
                pagination: {
                  ...state.pagination,
                  current: response.currentPage,
                  totalPages: response.totalPages,
                  totalRecordsCount: response.totalRecordsCount
                },
                completed: completed,
                progress: progress
              }
            }
        }
      }
  
      case FETCHING_ASSET_ANALYTICS_FOR_DOWNLOAD_FAILED: {
        const { error } = action.payload;

        return {
          ...state,
          download : {
            ...state.download,
            loading: false,
            assets:{
              ...state.download.assets,
              loading: false,
              completed: false,
              progress: false,
              error: error
            }
          }
        }
      }

      case INVALIDATE_ASSET_ANALYTICS_DOWNLOAD_DATA: {
        return {
          ...state,
          download : {
            ...state.download,
            loading: false,
            assets:{
              ...state.download.assets,
              loading: false,
              items: [],
              pagination: {
                current: -1,
                totalPages: 1,
                hasMore: false
              },
              progress: false,
              completed: false
            }
          }
        }
      }

    default:
      return state
  }
}